<template>
  <div style="height:100%" >
    <!-- 上 -->
    <div class="topContent">
      <el-carousel trigger="click" height="100%" :interval="5000" arrow="always" style="width:100%;height: 100%;">
        <el-carousel-item v-for="item in imgList" :key="item.name">
          <img :src="item.src" style="height:100%;width:100%;" alt="图片丢失了" :title="item.title"/>
        </el-carousel-item>
      </el-carousel>
      <!-- 登录头 -->
      <div class="topContent-logo">
        <!-- 左边logo -->
        <div class="topContent-left">
          <img style="width: 180px;" v-if="!!loginLogoUrl"
               :src="loginLogoUrl?loginLogoUrl:require('../assets/modularMain/logo.png')">
          <div class="topContent-logo-text">
            <div style="color: #404040;font-size: 17px;letter-spacing: 7px;">{{ pageConfig.loginSubName }}</div>
            <div style="font-size: 22px;font-weight: 600;color: #404040;">{{ pageConfig.loginProjectName }}</div>
          </div>
        </div>
        <div class="TopSloganUrlStyle">
          <img v-if="!!TopSloganUrl" :src="TopSloganUrl"/>
        </div>
        <!-- 右边登录 -->
        <div class="topContent-right-main">
          <!-- 微信-->
          <!-- <div style="width: 27px;margin-top: 25px;margin-right: 25px;"><img style="width:100%" src="../assets/modularMain/wx.png"></div> -->
          <!-- 下载中心-->
          <div @click="dowladUrlMethd()" class="dowlad-content">
            <div>
              <img style="width: 27px;" src="../assets/modularMain/xzzx.png">
              <span>下载中心</span>
            </div>
          </div>
          <!-- 登录平台 -->
          <div>
            <div v-if="JSON.stringify(userInfo) == '{}'" @click="getLoginCard" class="topContent-right">
              <img style="width: 24px;margin-right: 5px;" :class="[JSON.stringify(userInfo) != '{}'?'imgStyle':'']"
                   src="../assets/modularMain/login-Img2.png">
              <div class="loginDiv">
                <span v-if="JSON.stringify(userInfo) == '{}'">登录平台</span>
                <div v-if="JSON.stringify(userInfo) != '{}'" class="loginInfo">
                  <div>部门:{{ userInfo.orgName }}</div>
                  <div>人员:{{ userInfo.name }}</div>
                </div>
              </div>
            </div>
            <el-popover
              v-if="JSON.stringify(userInfo) != '{}'"
              placement="bottom"
              trigger="hover">
              <!-- <el-button slot="reference">click 激活</el-button> -->
              <div slot="reference" class="loginInfo">
                <img style="width: 24px;margin-right: 5px;" :class="[JSON.stringify(userInfo) != '{}'?'imgStyle':'']"
                     src="../assets/modularMain/login-Img2.png">
                <div style="display: inline-block;">
                  <div>部门:{{ userInfo.orgName }}</div>
                  <div>人员:{{ userInfo.name }}</div>
                </div>
              </div>
              <div>
                <div>单位：{{ (userInfo.topOrgName || "") }}</div>
                <div>部门：{{ (userInfo.orgName || "") }}</div>
                <div>职务：{{ (userInfo.position || "") }}</div>
                <div style="cursor: pointer;" @click="logout()">
                  <img style="width:12px;margin-right: 5px; margin-top: 10px;position: relative;
        top: 1px;" src="../assets/modularMain/loginOut.png"><span style="font-size:14px">退出登录</span>
                </div>
              </div>
            </el-popover>
          </div>
        </div>
      </div>
      <!-- 背景图描述 -->
      <!-- <div class="topbg-text">
          <div class="topbg-text-title">智控建设构筑新绿色交通示范</div>
          <div class="topbg-text-item">
              <span>智能化建造</span><span>信息化监管</span><span>生态化运营</span>
          </div>
      </div> -->
    </div>
    <div style="height: 60%;">
      <!-- 中 -->
      <div class="middleContent-content">
        <div style="display: flex;flex: 1">
          <!-- 视频 -->
          <video-detail :voidObj="voidObj"></video-detail>
          <blacksmith></blacksmith>
          <!-- 大事纪要 -->
          <div class="majorEvents-content">
            <div class="majorEvents-main">
              <div class="majorEvents-title">{{ pageConfig.newsTitle || 大事纪要 }}<span
                class="moreMajorEvent" @click="getMajorEventstable">更多</span></div>
              <div class="majorEvents-List">
                <div style="padding-right:5px" :class="{ anim: animate == true }" @mouseover="mouseOver"
                     @mouseout="mouseOut">
                  <div @click="getmajorEventInfo(i)" class="majorEvents-item" v-for="(i,index) in majorEventsLsit">
                    <div class="majorEvent-item-title">
                      <i class="pointStyle"></i><span>{{ i.TITLE_ }}</span>
                    </div>
                    <div class="timeStyle">{{ i.CREATE_DATE }}</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- 应用资源中心 -->
        <div class="middleContent">
          <div @click="goHome(i,index)" @mouseleave="mouseLeave(i,index)" @mouseover="btnClick(i,index)"
               :style="{'height':middleContentItemHeight,'background-image':'url(' + (resources[index].imgUrl) + ')'}"
               :class="[currentIndex==index?'proCaseactive':'','middleContent-main']"
               v-for="(i,index) in middleContentsecondList">
            <div style="display: flex;">
              <div class="middleContent-item-img"></div>
              <div class="middleContent-item">
                <div class="middleContent-item-main">{{ i.resourceName }}</div>
                <div class="middleContent-item-text">{{ i.text }}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- 下 -->
      <div class="bottomContent">
        <!-- <img class="bottomContent-img" src="../assets/modularMain/logo-bottom.png"> -->
        <div class="bottomContent-text">{{ pageConfig.copyright }}</div>
      </div>
    </div>
    <loginCard @closeLoginCard="closeLoginCard" class="loginCardStyle" v-if="isValidation" @appLogin="appLogin" @clickLogin="clickLogin($event,{})"/>
  </div>
</template>
<script>
import loginCard from './modularMainLogin.vue'
import {setToken, setLoginToken, removeToken} from "./../js/auth.js";
import {getConfigAsync, asyncMethod, getEntityName} from '../api/modularMain.js'
import videoDetail from '../components/modularMain/videoDetail'
import blacksmith from '../components/modularMain/blacksmith'
import request from "axios";

export default {
  components: {
    loginCard,
    videoDetail,
    blacksmith
  },
  data() {
    return {
      isValidation: false,
      currentIndex: -1,
      secondcurrentIndex: -1,
      proIndex: -1,
      triangleIndex: 0,
      organStructureLsit: [],
      triangleRight: '-19%',
      middleContentList: [
        {
          roleId: '-1',
          icon: require('../assets/modularMain/middleItem1.png'),
          title: '总指挥部',
          text: '整体概况，项目建设监管',
          url: '/zzhb'
        },
        {
          roleId: '606371844837126144',
          icon: require('../assets/modularMain/middleItem2.png'),
          title: '项目指挥部',
          text: '项目进度、质量、安全、投资管控',
          url: '/xmzhb'
        },
        {
          roleId: '606371985993932800',
          icon: require('../assets/modularMain/middleItem3.png'),
          title: '参建单位',
          text: '总承包、施工单位、监理单位、第三方机构',
          url: '/cjdw'
        },
      ],
      middleContentsecondList: [
        // {roleId:'-1',icon:require('../assets/modularMain/ico01-1.png'),title:'数字建设监管平台',text:'整体概况，项目建设监管',url:''},
        // {roleId:'606371844837126144',icon:require('../assets/modularMain/ico02-1.png'),title:'建设管理平台',text:'项目进度、质量、安全、投资管控',url:'/home'},
        // {roleId:'606371985993932800',icon:require('../assets/modularMain/ico03-1.png'),title:'办公自动化',text:'总承包、施工单位、监理单位、第三方机构',url:'/home'},
      ],
      resources:[
        {
          imgUrl:'/api/loginVideo/picture/ywgl.png'
        },{
          imgUrl:'/api/loginVideo/picture/szlsjm.png'
        },{
          imgUrl:'/api/loginVideo/picture/zhcx.png'
        }
      ],
      userInfo: {},
      roleArr: [],
      imgList:[
        {
          name: "logo1",
          src:' /api/loginVideo/picture/lbt1.png',
          title: ""
        },
        {
          name: "logo2",
          src: '/api/loginVideo/picture/lbt2.png',
          title: ""
        }],
      clickTag: {},
      proData: [
        {label: '泸水至腾冲', url: '/home', id: '586405471645945856', checked: false, code: '113'},
        {
          checked: false,
          children: null,
          code: "101",
          id: "578385163042844672",
          label: "龙陵至龙镇",
          parentId: "-1",
          state: "open",
          url: '/home',
          text: "龙陵（黄草坝）至龙镇桥段工程",
          type: "1"
        },
        {label: '永德至镇康', url: '/home', id: '578385217250828288', checked: false, code: '102'},
        {label: '耿马至沧源', url: '/home', id: '578385267984289792', checked: false, code: '103'},
        {label: '澜沧至西盟', url: '/home', id: '578385338415087616', checked: false, code: '104'},
        {label: '西盟至孟连', url: '/home', id: '578385395931709440', checked: false, code: '105'},
        {label: '景洪至勐腊', url: '/home', id: '578385489797054464', checked: false, code: ''},
        {label: '勐腊至红桥', url: '/home', id: '578385531604426752', checked: false, code: ''},
        {label: '勐腊至绿春', url: '/home', id: '578385448807919616', checked: false, code: ''},
        {label: '绿春至金平', url: '/home', id: '578385567964921856', checked: false, code: ''},
        {label: '个旧至马关', url: '/home', id: '578385610682306560', checked: false, code: ''},
        {label: '马关至西畴', url: '/home', id: '578385658445656064', checked: false, code: ''},
        {label: '西畴至富宁', url: '/home', id: '578385695865356288', checked: false, code: ''},
      ],
      activeTabs: 'first',
      majorEventsLsit: [
        {title: '总指挥部召开会议', time: '2022-03-26'},
        {title: '开展告诉公路项目建设节后复工复产安全生产检查', time: '2022-03-26'},
        {title: '公司一届七次职工代表大会', time: '2022-03-26'},
        {title: '“能通全通”“互联互通”第二推进组建设', time: '2022-03-26'},
        {title: '公司名称一届七次职工代表大会暨2022年度工作会议在昆召开', time: '2022-03-26'},
        {title: '党委完成第二轮巡察情况反馈', time: '2022-03-26'},
        {title: '举办2021年度财务决算布置暨年报审计机构进场会议', time: '2022-03-26'},
        {title: '百年征程 “羽”你共进 同心共建 幸福交发', time: '2022-03-26'},
        {title: '开展“宪法宣传周”系列活动', time: '2022-03-26'},
        {title: '公司名称召开2021年上半年经济运行形势分析会', time: '2022-03-26'},
        {title: '召开2021年度新员工入职培训', time: '2022-03-26'},
      ],
      showTag: false,
      timer: null,
      animate: false,
      pageConfig: {},
      loginLogoUrl: '',
      middleContentItemHeight: 0,
      TopSloganUrl: '',
      voidObj:{}
    }

  },
  mounted() {
    document.oncontextmenu = function () {
      return false;
    };
    this.getmajorEventsLsitMethd()
    const that = this;
    window.onresize = () => {
      return (() => {
        // console.log(window.innerWidth);
      })();
    };
    console.log("showTag", this.showTag)
    this.getmiddleContentsecondList()
    this.getmiddleContentList()
    // localStorage.setItem('loginUserInfo',JSON.stringify(response.data.data))
    if (!!JSON.parse(sessionStorage.getItem('loginUserInfo'))) {
      this.userInfo = JSON.parse(sessionStorage.getItem('loginUserInfo'))
    }
    this.getUserRoleIdMethd()

  },
  created() {
    this.getConfigAsyncMethd()
    //验证是否单点登录 - 直接进入首页
    this.validationToken();
  },
  methods: {

    dowladUrlMethd() {
      if (!!this.pageConfig.downloadUrl) {
        window.open(this.pageConfig.downloadUrl)
      }
    },
    getmajorEventInfo(data) {
      window.open(`/calendarEventsInfo?id=${data.ID_}&entityName=LOGIN_NEW_TRENDS`)
    },
    getMajorEventstable() {
      window.open('/calendarEventList?title=' + this.pageConfig.newsTitle)
    },
    //获取大事纪要列表
    getmajorEventsLsitMethd() {
      this.majorEventsLsit = []
      getEntityName('VIEW_LOGIN_NEW_TRENDS').then((res) => {
        if (res.rows.length > 0) {
          res.rows.forEach(e => {
            if (e.fields.RELEASE_STATUS_ == 'true') {
              this.majorEventsLsit.push(e.fields)
            }
          })
          this.majorEventsLsit.sort(function (a, b) {
            return Number(a.SORT_NUM_) - Number(b.SORT_NUM_)
          })
          this.majorEventsLsit.forEach((item,index) => {
            if (item.TYPE_ === '1') {
              this.voidObj = item
            }
          })
          if (this.majorEventsLsit.length > 8) {
            this.timer = setInterval(this.scroll, 2000);
          }
        }
      })
    },
    // 获取登录页信息
    async getConfigAsyncMethd() {
      await getConfigAsync().then(res => {
        // 退出地址，通过配置文件配置
        document.title = res.loginProjectName
        // sessionStorage.setItem("loginProjectName", res.loginProjectName);
        // sessionStorage.setItem("pageConfig", JSON.stringify(res));
        console.log("页面配置信息", res)
        this.pageConfig = res;
      })
      let TopSloganUrl = await asyncMethod(
        '/api/fs/files/search',
        this.$qs.stringify({
          'metaData.formId': '1111111111111111',
          'metaData.fileType': 'loginTopSloganUrl',
        }),
        'post'
      );
      console.log("TopSloganUrl", TopSloganUrl)
      if (TopSloganUrl.data && TopSloganUrl.data.length > 0) {
        this.TopSloganUrl = '/api/fs/files/download/' + TopSloganUrl.data[0].id

      }
      let loginLogoUrl = await asyncMethod(
        '/api/fs/files/search',
        this.$qs.stringify({
          'metaData.formId': '1111111111111111',
          'metaData.fileType': 'loginLogoUrl',
        }),
        'post'
      );
      if (loginLogoUrl.data && loginLogoUrl.data.length > 0) {
        this.loginLogoUrl = '/api/fs/files/download/' + loginLogoUrl.data[0].id

      }

      let resFile = await asyncMethod(
        '/api/fs/files/search',
        this.$qs.stringify({
          'metaData.formId': '1111111111111111',
          'metaData.fileType': 'loginBgUrl',
        }),
        'post'
      );
      if (resFile.data && resFile.data.length > 0) {
        if (resFile.data.length == 1) {
          //只有一个，不用显示item
          this.showItemBtn = 'none';
        }
        // this.imgList = [];
        // resFile.data.forEach((val) => {
        //   this.imgList.push({
        //     src: '/api/fs/files/download/' + val.id,
        //   })
        // })
      } else {
        //默认图片
        // this.imgList = [
        //   {
        //     name: "logo1",
        //     src: require("@/assets/modularMain/lb3.png"),
        //     title: ""
        //   },
        //   {
        //     name: "logo2",
        //     src: require("@/assets/modularMain/lb1.png"),
        //     title: ""
        //   },
        //   {
        //     name: "logo3",
        //     src: require("@/assets/modularMain/lb2.png"),
        //     title: ""
        //   },
        // ]
      }
    },
    scroll() {
      this.animate = true; // 因为在消息向上滚动的时候需要添加css3过渡动画，所以这里需要设置true
      setTimeout(() => {
        //  这里直接使用了es6的箭头函数，省去了处理this指向偏移问题，代码也比之前简化了很多
        this.majorEventsLsit.push(this.majorEventsLsit[0]); // 将数组的第一个元素添加到数组的
        this.majorEventsLsit.shift(); //删除数组的第一个元素
        this.animate = false; // margin-top 为0 的时候取消过渡动画，实现无缝滚动
      }, 1000);
    },
    mouseOver() {
      console.log('鼠标悬停')
      // this.animate = false;
      clearInterval(this.timer)
    },
    mouseOut() {
      // this.animate = true;
      if (this.majorEventsLsit.length >= 15) {
        this.timer = setInterval(this.scroll, 2000);

      }
      //   this.timer=setInterval(this.scroll, 2000);
    },
    getOrigan(url) {
      if (!!url) {
        window.open(url)

      }
    },
    triangleClick(data, index) {
      this.triangleIndex = index
      if (this.organStructureLsit.length == 3) {
        if (index == 0) {
          this.triangleRight = '-19%'

        } else if (index == 1) {
          this.triangleRight = '-47%'

        } else if (index == 2) {
          this.triangleRight = '-75%'

        }
      }
      if (this.organStructureLsit.length == 2) {
        if (index == 0) {
          this.triangleRight = '-34%'

        } else if (index == 1) {
          this.triangleRight = '-62%'

        }
      }


    },
    getmiddleContentsecondList() {
      this.$axios.post(`/api/resource/getResourceListNoPage?parentId=618745284009885696`).then(res => {
        console.log("三大块", res.data.data)
        if (res.data.succeed && res.data.data.length > 0) {
          let arryNew = []
          res.data.data.forEach(async (e, index) => {
            let Obj = {}
            const LoginSourceIcon = await this.getLoginIcon(e.resourceId).then(res => res)
            //  console.log("LoginSourceIcon三大块",LoginSourceIcon)
            Obj = e
            e.icon = !!LoginSourceIcon ? LoginSourceIcon.url : ''
            this.$delete(e, 'icon');
            this.$set(e, 'icon', LoginSourceIcon.url)
            // e.icon=!!LoginSourceIcon?LoginSourceIcon.url:''
            // this.$set(e,'icon',!!LoginSourceIcon?LoginSourceIcon.url:'')

          })

          // setTimeout(function(){
          //      console.log("rryNew222333",arryNew)

          // arryNew.sort((a,b)=>{
          //     console.log("arryNew222",a,b)
          // return Number(a.orderNo)- Number(b.orderNo)
          // })
          // },800)
          //  this.organStructureLsit=arryNew
          this.organStructureLsit = res.data.data
          this.triangleRight = this.organStructureLsit.length == 3 ? '-19%' : '-34%'

          console.log("organStructureLsit三大块", this.organStructureLsit)

        }

      })

    },
    getmiddleContentList() {
      console.log("走这了吗")
      // let that = this
      this.middleContentsecondList = []
      this.$axios.get(`/api/resource/getResourceListNoPage?parentId=618745325062696960`).then(res => {
        console.log("结果resource11", res)
        if (res.data.succeed) {
          if (res.data.data.length > 0) {
            console.log(res.data.data.length, 8999999);
            let topData = (res.data.data.length - 1) * 10 / res.data.data.length
            let height = 1 / res.data.data.length * 100
            this.middleContentItemHeight = `calc(${height}% - ${topData}px)`
            let arryNew = []
            this.middleContentsecondList = res.data.data
            res.data.data.forEach(async e => {
              let Obj = {}
              Obj = e
              const NavRoleArr = await this.getNavRole(e.resourceId).then(res => res)
              e.NavRoleArr = NavRoleArr.data
              const LoginSourceIcon = await this.getLoginIcon(e.resourceId).then(res => res)
              e.icon = LoginSourceIcon.url
              e.icon = !!LoginSourceIcon ? LoginSourceIcon.url : ''
              arryNew.push(Obj)
              this.$delete(e, 'icon');
              this.$set(e, 'icon', LoginSourceIcon.url)
              this.$set(e, 'NavRoleArr', NavRoleArr.data)
            })

            // setTimeout(function(){
            //     arryNew.sort((a,b)=>{
            //         console.log("arryNew2225555",a,b)
            //     return Number(a.orderNo)- Number(b.orderNo)
            //     })
            //     },1000)
            // this.middleContentItemHeight=100/this.middleContentsecondList.length - 5+'%'
            console.log("getmiddleContentList结果", this.middleContentsecondList)

          }

        }
      })

    },
    // 获取三大跳转菜单权限
    getNavRole(resourceId) {
      return this.$axios.post(`/api/resource/getRoleIdByResourceId?resourceId=${resourceId}`).then(res => {
        if (res.data.succeed) {
          return Promise.resolve({
            data: res.data.data,
            success: true
          });
        }

      })
    },
    // 获取资源图标地址
    getLoginIcon(formId) {
      let params = {
        'metaData.formId': formId,
        'metaData.fileType': 'loginSourceUrl'
      }
      return this.$axios.post('/api/fs/files/search', this.$qs.stringify(params)).then(res => {
        console.log("图标结果", res)
        if (res.data && res.data.length > 0) {
          return Promise.resolve({
            url: "/api/fs/files/download/" + res.data[0].id,
            success: true
          });
        }

      })
    },
    // 获取资源图标地址
    getLoginIcon(formId) {
      let params = {
        'metaData.formId': formId,
        'metaData.fileType': 'loginSourceUrl'
      }
      return this.$axios.post('/api/fs/files/search', this.$qs.stringify(params)).then(res => {
        console.log("图标结果", res)
        if (res.data && res.data.length > 0) {
          return Promise.resolve({
            url: "/api/fs/files/download/" + res.data[0].id,
            success: true
          });
        }

      })
    },
    goModularMethd(data, index) {
      window.open(data.url)

    },
    mouseleaveMethd() {
      this.secondcurrentIndex = -1

    },
    getProject(data) {
      console.log("项目id", data)
      sessionStorage.setItem("modularMainProData", JSON.stringify(data))
      // console.log(JSON.parse(localStorage.getItem("Admin-Data")),sessionStorage.getItem("isLogin")=='true')
      if (JSON.stringify(this.userInfo) == '{}') {
        // this.$message.warning("请先登录")
        this.clickTag = data
        this.isValidation = true
        return
      }
      if (data.url != '') {
        window.open(data.url)
      }
    },
    logout() {
      this.$confirm('是否确认退出登录？')
        .then(_ => {
          //退出登录
          this.$axios
            .post("/api/login/logoutVue")
            .then(response => {
              if (response.data.succeed) {
                removeToken();
                this.userInfo = {}
                sessionStorage.removeItem('loginUserInfo')
              }
            })
            .catch(error => {
              this.$message.error("异常，请联系管理员！");
              console.log("error:" + error.toString());
            });
          //退出登录
          this.$axios
            .get("http://220.165.247.94:8280/ssoserver/login/loginout")
            .then(response => {
            })
            .catch(error => {
            });
        })
        .catch(_ => {
        });
    },
    closeLoginCard() {
      console.log("点击关闭2")
      this.isValidation = false
      console.log(this.isValidation);

    },
    // 获取登录人角色
    getUserRoleIdMethd() {
      if (!this.userInfo.userId) {
        return
      }
      this.$axios.post(`/api/baseRole/getRoleByUserId?userId=${this.userInfo.userId}`).then(res => {
        console.log("登录角色", res)
        this.roleArr = []
        if (res.data.succeed) {
          if (res.data.data.length > 0) {
            res.data.data.forEach(t => {
              // if(t.key=="superRole"){
              this.roleArr.push(t)
              // }
            })
            if (JSON.stringify(this.clickTag) != '{}') {
              if (this.clickTag.url != '') {
                this.goHome(this.clickTag)
              }

            }
          }
        }

      })

    },
    // 判断是否已经登录
    goHome(data, index) {
      let goHome = localStorage.getItem('goHome')
      console.log(goHome,648);
      console.log("藕断", data, this.roleArr)
      // if(data.title=='项目指挥部'&&index==1){
      //     return
      // }
      // console.log(JSON.parse(localStorage.getItem("Admin-Data")),sessionStorage.getItem("isLogin")=='true')
      if (JSON.stringify(this.userInfo) == '{}') {
        // this.$message.warning("请先登录")
        this.clickTag = data
        this.isValidation = true
        return
      }
      if (!!goHome && JSON.stringify(this.userInfo) !== '{}') {
        let isHaveRole = false
        console.log("匹配结果1", this.roleArr, data)
        // 登录后判断是否拥有此角色
        this.roleArr.forEach(e => {
          data.NavRoleArr.forEach(t => {
            if (e.roleId == t.ROLE_ID) {
              sessionStorage.setItem('roleInfo', JSON.stringify(e))
              isHaveRole = true
              return
            }
          })
          // if(e.roleId==data.roleId){
          //     sessionStorage.setItem('roleInfo',JSON.stringify(e))
          //     isHaveRole=true
          //     return
          // }
        })
        if (isHaveRole) {
          if (data.url != '') {
            window.open(data.url)
          }
        }
      } else {
        //退出登录
        this.$axios.post("/api/login/logoutVue").then(response => {
          if (response.data.succeed) {
            removeToken();
            this.userInfo = {}
            sessionStorage.removeItem('loginUserInfo')
          }
        })
          .catch(error => {
            this.$message.error("异常，请联系管理员！");
            console.log("error:" + error.toString());
          });
        //退出登录
        this.$axios
          .get("http://220.165.247.94:8280/ssoserver/login/loginout")
          .then(response => {
          })
          .catch(error => {
          });
        // this.$message.warning("登录已过期，请重新登录")
        this.clickTag = data
        this.isValidation = true
      }
    },
    getLoginCard() {
      this.isValidation = true

    },
    proIndexClick(i, index) {
      this.proIndex = index;
    },
    secondBtnClick(i, index) {
      this.secondcurrentIndex = index;
    },
    btnClick(i, index) {
      this.currentIndex = index;
    },
    mouseLeave(i, index) {
      this.currentIndex = '-1';
    },
    validationToken() {
      const routParams = this.$route.query;

      if (routParams && routParams.token) {
        this.isValidation = false;
        const loading = this.$loading({
          lock: true,
          text: "跳转中...",
          spinner: "el-icon-loading",
          background: "rgba(0, 0, 0, 0.7)"
        });
        this.$axios
          .post("/api/login/checkByMoblie", this.$qs.stringify(routParams))
          .then(response => {
            loading.close();
            this.dealResponse(response);
          })
          .catch(error => {
            this.$message.error("异常，请联系管理员！");
            console.log(error);
            loading.close();
          });
      }
    },
    appLogin(userInfo) {
      // 多页面通讯
      localStorage.setItem('goHome','true')
      sessionStorage.setItem("isLogin", true);
      this.$axios.post("/api/login/check", this.$qs.stringify(userInfo)).then(response => {
        if (response.data.success || response.data.succeed) {
          this.isValidation = false
          this.userInfo = response.data.data
          sessionStorage.setItem('loginUserInfo', JSON.stringify(response.data.data))
          // localStorage.setItem('Admin-Data',JSON.stringify(response.data.data))
          this.getUserRoleIdMethd()
          this.dealResponse(response);
          //   JSON.stringify(this.userInfo) == '{}'  this.clickTag
          if (JSON.stringify(this.clickTag) != '{}') {
            if (this.clickTag.url != '') {
              //   this.goHome(this.clickTag)
            }
          }
        } else {
          this.$message.error(response.data.msg);
        }
      })
        .catch(error => {
          this.$message.error("异常，请联系管理员！");
          console.log("error:" + error.toString());
        });
    },
    clickLogin(userInfo) {
      sessionStorage.setItem("isLogin", true);
      localStorage.setItem('goHome','true')
      this.$axios
        .post("/api/login/checkByMoblie", this.$qs.stringify(userInfo))
        .then(response => {
          this.isValidation = false
          this.userInfo = response.data.data
          sessionStorage.setItem('loginUserInfo', JSON.stringify(response.data.data))
          // localStorage.setItem('Admin-Data',JSON.stringify(response.data.data))
          this.getUserRoleIdMethd()
          this.dealResponse(response);
          //   JSON.stringify(this.userInfo) == '{}'  this.clickTag
          if (JSON.stringify(this.clickTag) != '{}') {
            if (this.clickTag.url != '') {
              //   this.goHome(this.clickTag)
            }
          }
        })
        .catch(error => {
          this.$message.error("异常，请联系管理员！");
          console.log("error:" + error.toString());
        });
    },
    dealResponse(response) {
      console.log("结果dealResponse", response.data.data)
      if (response.data.succeed) {
        setToken(response.data.data.name, response.data.data);
        // localStorage.setItem('Admin-Data',JSON.stringify(response.data.data))
        setLoginToken(response.headers.token);
        window.sessionStorage["tempFlag"] = true;
        console.log(localStorage.getItem("Admin-Msg"));
        sessionStorage.setItem("logined", true);
        //登录地址，通过配置文件配置
        // this.$router.push("home");
      } else {
        this.$message.error(response.data.msg ? response.data.msg : "失败");
      }
    }
  }
}
</script>
<style lang="less" scoped>
.topContent {
  height: 40%;
  background-color: rgb(241, 244, 255);

  .topContent-logo {
    display: flex;
    justify-content: space-between;
    position: absolute;
    top: 0px;
    z-index: 999;
    width: 100%;
    background-color: #ffffffc2;
    // padding-bottom: 20px;
  }

  .topContent-logo-text {
    display: inline-block;
    position: relative;
    top: -4px;
    margin-left: 5px;
  }

  .topContent-left {
    padding-top: 15px;
    padding-left: 15px;
    padding-bottom: 15px;
    display: flex;
    align-items: center;
  }

  .topContent-right {
    //padding-top: 25px;
    padding-right: 20px;
    cursor: pointer;
    display: flex;
    align-items: center;
  }

  .loginDiv {
    display: inline-block;
    font-size: 14px;
    color: rgb(51, 51, 51);
    //position: relative;
    //top: -4px;
  }

  .topbg-text {
    padding-top: 10%;
    padding-left: 223px;
  }

  .topbg-text-title {
    font-weight: 600;
    font-size: 46px;
    color: #252b3a;
    margin-bottom: 10px;
    letter-spacing: 3px;
  }

  .topbg-text-item {
    font-size: 18px;
    color: #252b3a;

    span {
      margin-right: 10px;
    }
  }
}

.middleContent-content {
  height: calc(100% - 35px);
  //position: relative;
  display: flex;
  justify-content: center;
  width: 100%;
  box-sizing: border-box;
  padding: 18px 70px;

  .middleContent-content-left {
    width: 30%;
  }

  .explain-text {
    position: absolute;
    top: 15px;
    left: 25px;
    color: #c4c4c4;
    font-size: 14px;
  }
}

.middleContent-main:hover {
  background-color: #fff;
  box-shadow: 0 2px 10px 0 rgba(0, 0, 0, 0.3);
}

.middleContent {
  // display: flex;
  // justify-content: center;
  margin-left: 12px;
  height: 100%;
  width: 20%;
  box-sizing: border-box;

  .middleContent-main {
    // margin: 0px 10px;
    width: 100%;
    cursor: pointer;
    box-sizing: border-box;
    // height: 30%;
    // background-image: url(../assets/modularMain/blue01.png);
    background-repeat: no-repeat;
    background-size: 100% 100%;
    display: flex;
    align-items: center;
    margin-top: 10px;
  }

  .middleContent-main:nth-child(1) {
    margin-top: 0;
  }

  .middleContentBg0 {
    background-image: url(../assets/modularMain/blue01.png);
  }

  .middleContentBg0:hover {
    background-image: url(../assets/modularMain/blue01-1.png);
  }

  .middleContentBg1 {
    background-image: url(../assets/modularMain/lv01.png);
  }

  .middleContentBg2 {
    background-image: url(../assets/modularMain/zi01.png);
  }

  .middleContentBg1:hover {
    background-image: url(../assets/modularMain/lv01-1.png);
  }

  .middleContentBg2:hover {
    background-image: url(../assets/modularMain/zi01-1.png);
  }

  // margin-top: 30px;
  .middleContent-item {
    display: inline-block;
  }

  .middleContent-item-main {
    font-size: 18px;
    color: #2e3442;
    font-weight: 600;
    // margin-bottom: 5px;
    // margin-top: 15px;
  }

  .middleContent-item-text {
    font-size: 14px;
    color: #6b738a;
  }

  .middleContent-item-img {
    // width: 45px;
    margin-right: 20px;
    // position: relative;
    // top: 7px;
  }
}

.bottomContent {
  display: flex;
  align-items: center;
  justify-content: center;
  position: absolute;
  bottom: 1px;
  text-align: center;
  width: 100%;
  height: 35px;
  background-color: #e2e2e2;

  .bottomContent-text {
    display: inline-block;
    font-size: 12px;
    color: #a7a7a7;
    white-space: pre-wrap;
  }

  .bottomContent-img {
    width: 67px;
    position: relative;
    top: 5px;
    margin-right: 10px;
  }

}

.proCaseactive {
  // background-image: url(../assets/modularMain/middle-acitve-bg.png);
  // margin: 0px 10px;
  padding: 30px 15px;
  // background-color: #fff;
}

.proCaseactive-second {
  .middleContent-item-main {
    color: rgb(25, 212, 254)
  }

}

.imgStyle {
  //position: relative;
  //top: -6px;
}

.loginCardStyle {
  z-index: 99;
}

.loginInfo {
  font-size: 14px;
  //margin-top: 20px;
  margin-right: 20px;
  cursor: pointer;
  display: flex;
  align-items: center;
}

.proDataStyle {
  display: flex;
  flex-wrap: wrap;

  div {
    margin: 5px 6px;
    color: #555555;
  }
}

.proIndexactive {
  font-weight: 600;
  color: #5ba3fd !important;
}

.topContent-right-main {
  display: flex;
  align-items: center;

  .dowlad-content {
    //padding-top: 25px;
    padding-right: 20px;
    cursor: pointer;

    span {
      font-size: 14px;
      color: #333333;
      position: relative;
      top: -8px;
    }
  }
}

.majorEvents-content {
  width: 35%;
  height: 100%;
  border: 1.5px solid #eaeaea;
  border-radius: 5px;
  //padding: 17px 0px;
  padding: 0 15px 15px 15px;
  font-size: 14px;
  //margin: 0 8px;
  box-sizing: border-box;

  .majorEvents-title {
    height: 64px;
    font-weight: 600;
    position: relative;
    z-index: 9;
    line-height: 64px;
    background-color: #fff;
    font-size: 14px;
    color: #333333;
  }

  .majorEvents-item {
    display: flex;
    justify-content: space-between;
    padding: 5px 0px;
    border-bottom: 1px solid #f4f4f4;
    width: 100%;
    cursor: pointer;

  }

  .timeStyle {
    line-height: 22px;
    color: #999;
  }

  .majorEvents-main {
    width: 100%;
    height: 100%;
  }

  .majorEvents-List {
    width: 100%;
    height: 85%;
    overflow: auto;
  }

  /*滚动条样式*/

  .majorEvents-List::-webkit-scrollbar {
    width: 2px;
    /*height: 4px;*/
  }

  .majorEvents-List::-webkit-scrollbar-thumb {
    border-radius: 20px;
    -webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.026);
    background: rgba(0, 0, 0, 0.026);
  }

  .majorEvents-List::-webkit-scrollbar-track {
    -webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.026);
    border-radius: 20px;
    background: rgba(0, 0, 0, 0.016);

  }

  .majorEvent-item-title {
    width: 80%;
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;

    span {
      color: #5d5d5d;
    }
  }

  .majorEvents-item:hover {
    .majorEvent-item-title {
      span {
        color: #000000;
        font-weight: 600;
      }

    }

    .pointStyle {
      background-color: #3680ff;
    }
  }

  .pointStyle {
    width: 5px;
    height: 5px;
    display: inline-block;
    background-color: #e5e5e5;
    border-radius: 10px;
    position: relative;
    top: -3px;
    margin-right: 8px;
  }
}

.organStructure-main {
  display: flex;
  justify-content: center;
  width: 100%;
}

.organStructure-item {
  text-align: center;
  width: 28%;
  cursor: pointer;

  .organStructure-item-main {
    padding: 15px 10px;
    margin: 0px 10px;
    background-color: rgb(242, 242, 242);
    border-radius: 5px;
  }

  .organStructure-item-main:hover {
    background-color: rgb(169, 212, 254);

  }
}

.organStructureactive {
  .organStructure-item-main {
    background-color: rgb(169, 212, 254);

  }
}

.triangle-content {
  border-bottom: 1px solid #dbd8d8;

  .triangle-main {
    position: relative;
    display: inline-block;
    top: 4px;
  }

  .triangle1 {
    width: 0px;
    border-top: 10px solid transparent;
    border-right: 10px solid transparent;
    border-bottom: 10px solid #dbd8d8;
    border-left: 10px solid transparent;
  }

  .triangle2 {
    width: 0px;
    border-top: 10px solid transparent;
    border-right: 10px solid transparent;
    border-bottom: 10px solid #fff;
    border-left: 10px solid transparent;
    position: absolute;
    top: 1px;
    z-index: 9;
  }
}

.organStructure-remark {
  font-size: 12px;
  color: #5d5d5d;
  margin-top: 10px;
  text-decoration: underline;
  cursor: pointer;
  line-height: 1.7;
}

.anim {
  transition: all 1s;
  margin-top: -33px;
  padding-bottom: 33px;
}

.moreMajorEvent {
  position: absolute;
  right: 1px;
  cursor: pointer;
  color: #959595;
  font-size: 12px;
}

.TopSloganUrlStyle {
  align-items: center;
  display: flex;
}
</style>



// WEBPACK FOOTER //
// src/views/modularMainMl2.vue